import React from 'react'
import 'antd/dist/reset.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import Switcher from './routers/Switcher/Switcher'

function App () {
  return (
      <BrowserRouter>
          <HelmetProvider>
              <Routes>
                  <Route path="*" element={<Switcher/>}/>
              </Routes>
          </HelmetProvider>
      </BrowserRouter>
  )
}

export default App
